"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';

const badgeVariants = tv({
  base: "inline-flex items-center rounded-full font-medium select-none whitespace-nowrap",
  variants: {
    variant: {
      solid: "",
      subtle: "border border-border-subtle bg-bg-subtle text-fg-default [&_svg]:text-fg-muted",
      outline: "border-2 border-border-default text-fg-default"
    },
    size: {
      sm: "text-xs leading-[1.125rem] px-2 h-5 gap-1 [&_svg]:w-3 [&_svg]:h-3",
      md: "text-xs leading-[1.125rem] px-2.5 h-6 gap-1.5 [&_svg]:w-4 [&_svg]:h-4",
      lg: "text-sm leading-5 px-3 h-7 gap-1.5 [&_svg]:w-4 [&_svg]:h-4"
    },
    colorPalette: {
      gray: ""
    }
  },
  compoundVariants: [{ variant: "solid", colorPalette: "gray", class: "bg-gray-default text-gray-fg" }],
  defaultVariants: {
    variant: "subtle",
    size: "md"
  }
});
const Badge = forwardRef(
  ({ className, variant, size, colorPalette, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: badgeVariants({ variant, size, colorPalette, className }), ...props })
);
Badge.displayName = "Badge";

export { Badge };
